import { useEffect } from "react";

const TikTokEmbed = ({ url }) => {
  const match = url.match(/tiktok\.com\/@([\w.]+)\/video\/(\d+)/);
  if (!match) return null;
  const [, user, videoId] = match;
  return (
    <blockquote
      className="tiktok-embed"
      cite={url}
      data-video-id={videoId}
      style={{ maxWidth: 605, minWidth: 300 }}
      data-testid={`tiktok-embed-${videoId}`}
    >
      <section>
        <a target="_blank" rel="noopener noreferrer" href={url}>
          @{user} en TikTok
        </a>
      </section>
    </blockquote>
  );
};

export const TikTokEmbedLoader = () => {
  useEffect(() => {
    document.querySelector("script[data-tiktok-embed]")?.remove();
    const s = document.createElement("script");
    s.src = "https://www.tiktok.com/embed.js";
    s.async = true;
    s.setAttribute("data-tiktok-embed", "1");
    document.body.appendChild(s);
  }, []);
  return null;
};

export default TikTokEmbed;
